<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24"
       fill="none"
       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
       class="feather feather-chevron-right">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
</template>

<script>
export default {
  name: 'ChevronRightIcon',
  props: {
    size: {
      type: String,
      default: '1.5rem',
    },
  },
};
</script>
